export const ID_CONDITION_INSPECTION = "ID Condition Inspection";
export const PRE_SALE_INSPECTION = "Pre-Sale Inspection";
export const PRE_SALE_SHORT_NAME = "PSR";
